import React, { useEffect, useState } from 'react'
import "./style.scss";

interface Option {
    id: string;
    label: string;
    info?: string
}

interface RadioTileGroupProps {
    options: Option[];
    name: string;
    defaultValue?: string;
    onChange?: (value: string) => void;
    selectFirstWhenNoValueProvided?: boolean,
    disabled?: boolean
}

const RadioTileGroup: React.FC<RadioTileGroupProps> = ({ options, name, defaultValue, onChange, selectFirstWhenNoValueProvided = true, disabled = false }) => {
    const [selected, setSelected] = useState<string>(defaultValue || (selectFirstWhenNoValueProvided ? options[0]?.id : ''));

    useEffect(() => {
        if (defaultValue) {
            setSelected(defaultValue);
        } else if (selectFirstWhenNoValueProvided && options.length > 0) {
            setSelected(options[0].id);
        }
    }, [defaultValue, options, selectFirstWhenNoValueProvided, disabled]);

    const handleChange = (value: string) => {
        if (disabled || selected === value) return;
        setSelected(value);
        if (onChange) onChange(value);
    };

    return (
        <div className='radio-tile-group'>
            {options.map((option) => {
                const isChecked = selected === option.id;
                return (
                    <div className={`radio-tile ${isChecked ? 'selected' : ''}`} onClick={() => handleChange(option.id)} key={option.id}>
                        <span>{option.label}</span>
                        {
                            option.info &&
                            <div className="info-text">
                                {option.info}
                            </div>
                        }
                    </div>
                );
            })}
        </div>
    );
};

export default RadioTileGroup;